import { Typography, Container } from "@mui/material";
import { useState, useContext, useEffect } from "react";
import Topic from "components/left-side/Topic";
import Subtopic from "components/left-side/Subtopic";
import { HashContext } from "context/hash-context";
import styles from "./styles";

const getSectionElement = ({ section }) => (
  <Typography key={section} sx={styles}>
    {section}
  </Typography>
);

function SideMenu({ sections }) {
  const [elements, setElements] = useState([]);
  const routeId = useContext(HashContext);

  // TODO fix this check
  if (sections.length && !elements.length) {
    const newSideMenuContent = [];

    for (const section of sections) {
      newSideMenuContent.push(getSectionElement(section));

      section.items.forEach((topic) => {
        newSideMenuContent.push(<Topic key={topic.anchorTag} props={topic} />);

        topic.subtopics.forEach((subtopic) => {
          newSideMenuContent.push(
            <Subtopic key={subtopic.anchorTag} props={subtopic} />
          );
        });
      });
    }

    setElements(newSideMenuContent);
  }

  // Scroll to the side menu when hash changes
  useEffect(() => {
    if (routeId) {
      // Function to find the side menu with id to scroll
      const scrollToElement = () => {
        const menuElement = document.getElementById(`${routeId}-menu`);
        if (menuElement) {
          menuElement.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      };

      // Execute the scroll after a short delay
      setTimeout(scrollToElement, 1000);
    }
  }, [routeId]);

  return <Container disableGutters>{elements}</Container>;
}

export default SideMenu;
